import React, {memo, useContext, useEffect, useState} from 'react';
import {Translate} from '../../components/translations';
import classNames from 'classnames';
import {SectionProps} from '../types';
import './styles.scss';
import {UserContext} from '../../contexts/user-context';

const Section = (props: SectionProps) => {
  const [showPromo, setShowPromo] = useState(false);
  const {hexofyUser} = useContext(UserContext);
  // const {data: hexosparkUserData, loading} = useQuery(HEXOSPARK_USER, {
  //   fetchPolicy: 'no-cache',
  // });

  const generateClassName = (props: SectionProps): string => {
    if (props.grey) {
      return 'grey_section_area';
    } else if (props.primary) {
      return 'blue_section_area';
    } else if (props.light) {
      return 'light_section_area';
    } else if (props.lightGrey) {
      return 'light_grey_section_area';
    } else if (props.dark) {
      return `dark_section_area ${props.gradient ? 'gradient' : ''}`;
    } else {
      return 'light_section_area';
    }
  };

  const className = generateClassName(props);

  useEffect(() => {
    const promoPage = global?.window?.location?.href?.includes('/promo');
    if (hexofyUser?.hfUser?.pricing_package && props.lgPd && promoPage) {
      setShowPromo(
        hexofyUser?.hfUser?.pricing_package_interval !== 'LTD' &&
          hexofyUser?.hfUser?.pricing_package &&
          hexofyUser?.hfUser?.pricing_package !== 'FREE'
          ? false
          : true,
      );
    } else if (props.lgPd && promoPage) {
      hexofyUser && setShowPromo(true);
    } else if (
      hexofyUser &&
      (hexofyUser?.hfUser?.pricing_package === 'FREE' || !hexofyUser?.hfUser?.pricing_package) &&
      props.lgPd
    ) {
      setShowPromo(true);
    }
  }, [hexofyUser]);

  return (
    <div
      style={props.style && props.style}
      className={`${props.className ? `${props.className} ${className}` : className} `}
    >
      <div
        className={`${props.pageheroPading || props.pagehero ? `pagehero-padding` : ''} ${
          true ? 'lg-pd' : ''
        } container`}
      >
        {props.title && (
          <div className="sec_title text-center mb_70 wow fadeInUp" data-wow-delay="0.2s">
            <h2 className="f_p l_height48 f_600 t_color" style={{color: '#263b5e'}}>
              {typeof props.title === 'string' ? <Translate name={props.title} /> : props.title}
            </h2>
            {props.subtitle && (
              <p className="f_300 f_size_16 mb-0">
                {typeof props.subtitle === 'string' ? <Translate name={props.subtitle} /> : props.subtitle}
              </p>
            )}
          </div>
        )}
        <div
          className={classNames('row', {
            'justify-content-center': props.about,
          })}
        >
          {props.children}
        </div>
      </div>
    </div>
  );
};

export default memo(Section);
